'use client' // Error boundaries must be Client Components


export default function Error() {
    return (
        <div>
            <h2>Something went wrong!</h2>
        </div>
    )
}